module.exports = __webpack_public_path__ + "img/poopr-wide.a4325bf4.png";